import React, { Component } from 'react';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import RightMessage from "./RightMessage";
import LeftMessage from "./LeftMessage";
import CenterMessage from "./CenterMessage";
import {helperFunctions} from "../../lib/helperFunctions";



@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class ChatMessages extends Component {

    constructor(props) {
        super(props);
    }


    render() {
        const { t } = this.props;
        return (
            <>

                {this.props.messages
                    .map((messageMap, index) => {

                        if(
                            (messageMap.sender===3 && messageMap.send_type==="auto" && messageMap.receiver===1)
                            || (messageMap.sender===2 && messageMap.send_type==="manuel" && messageMap.receiver===1)

                        ){
                            return <RightMessage message={messageMap} nextMessage={this.props.messages[index+1]} beforeMessage={this.props.messages[index-1]} id={this.props.id}/>
                        }

                        if(
                            (messageMap.sender===3 && messageMap.send_type==="auto" && messageMap.message_type=='prechatform' && messageMap.receiver===2)
                            || (messageMap.sender===1 && messageMap.send_type==="manuel" && messageMap.receiver===2)

                        ){
                            return <LeftMessage message={messageMap} nextMessage={this.props.messages[index+1]} beforeMessage={this.props.messages[index-1]} id={this.props.id}/>
                        }
                        if(messageMap.sender===3 && messageMap.send_type==="auto" && (messageMap.receiver===3 || messageMap.receiver===2)) {
                            return <CenterMessage message={messageMap} id={this.props.id}/>
                        }




                    })}


          </>
        )

    }
}

export default withTranslation()(ChatMessages);




